import { Suspense } from "react"
import LoadingComponent from "./LoadingComponent"

const SuspenseComponent = ({ children }: { children: React.ReactNode }) => {
    return (
        <Suspense fallback={<LoadingComponent />} >
            {children}
        </Suspense>)
}
export default SuspenseComponent